import { FOOTER_COLUMNS, LEGAL_LINKS, BRAND } from "@/data/brand";
import { Check } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-asphalt text-white">
      {/* CTA band */}
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="text-3xl font-bold text-white">
                AI Regulation is here, GDPRLocal can help
              </h2>
              <p className="mt-4 max-w-xl text-white/80">
                Need help with an AI risk assessment? Looking for advice on governance? Need a complete
                set of compliance documentation? Our experienced data protection and AI consultants can help.
              </p>
              <div className="mt-5 flex flex-wrap gap-6">
                <span className="flex items-center gap-2 text-sm text-white/90">
                  <Check className="h-4 w-4 text-aqua" /> No credit card required
                </span>
                <span className="flex items-center gap-2 text-sm text-white/90">
                  <Check className="h-4 w-4 text-aqua" /> Easy setup
                </span>
              </div>
            </div>
            <div className="lg:justify-self-end">
              <a
                href={BRAND.PORTAL_REGISTER}
                className="gl-primary-btn inline-block px-6 py-3 text-base"
                data-testid="footer-signup-btn"
              >
                Sign up free
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Columns */}
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h3 className="mb-4 text-sm font-bold uppercase tracking-wide text-white">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-white/75 transition-colors hover:text-aqua">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 text-sm text-white/70">
          <p className="font-medium text-white">GDPRLocal Ltd, UK Reg: 12969035</p>
          <p className="mt-1">1st Floor Front Suite, 27-29 North Street, Brighton, England, BN1 1EB</p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-4 py-6 text-sm text-white/70 sm:px-6 md:flex-row md:items-center lg:px-8">
          <span>GDPRLocal 2026 &copy; All Rights Reserved</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {LEGAL_LINKS.map((l) => (
              <a key={l.label} href={l.href} className="transition-colors hover:text-aqua">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
